/**
 * TL-01 / C9 — la formación de cada taller vive DENTRO del icono del propio
 * taller en la sección Servicios (nunca en la biblioteca general) y su
 * acceso es VITALICIO (lo resuelve el backend con el histórico de servicios).
 */
import { getTrainingWorkshops } from '../clients/farmavel/index.js'

const WORKSHOP_CODES = ['TALLER_INHALADORES', 'TALLER_INSULINAS']

let pendingWorkshop = null

export function takePendingWorkshop() {
    const value = pendingWorkshop
    pendingWorkshop = null
    return value
}

/**
 * Habilita los iconos de taller accesibles (aunque el servicio ya no esté
 * activo — vitalicio) y engancha su click para abrir la formación del taller.
 */
export async function initWorkshopIcons() {
    if (!localStorage.getItem('farmavel_token')) return

    const response = await getTrainingWorkshops()
    const accessible = new Set(
        (response?.data ?? []).flatMap((workshop) => workshop.services ?? [])
    )

    WORKSHOP_CODES.forEach((code) => {
        const icon = document.getElementById(`service_${code}`)
        if (!icon) return

        if (accessible.has(code)) {
            icon.classList.remove('disabled')
            icon.setAttribute('data-workshop', code)

            if (!icon.dataset.workshopBound) {
                icon.dataset.workshopBound = '1'
                icon.addEventListener('click', (e) => {
                    e.preventDefault()
                    if (icon.classList.contains('disabled')) return
                    pendingWorkshop = code
                    document.querySelector('nav [aria-section="section_formacion"]')?.click()
                })
            }
        }
    })
}
